import blog from '../views/blog/index.vue'
import blog_create from '../views/blog/create.vue'
import blog_edit from '../views/blog/edit.vue'
import blog_import from '../views/blog/import.vue'

const routes = [
  {
    path: "/blog",
    name: "blog",
    component: blog,
    meta: { authOnly: true },
  },
  {
    path: "/blog/create",
    name: "blog_create",
    component: blog_create,
    meta: { authOnly: true },
  },
  {
    path: "/blog/edit/:uuid",
    name: "blog_edit",
    component: blog_edit,
    meta: { authOnly: true },
  },
  {
    path: "/blog/import",
    name: "blog_import",
    component: blog_import,
    meta: { authOnly: true },
  },]

export default routes
